import { Type } from 'class-transformer';
import { ContactInfoRawDto } from './contact-info-raw-dto';
import { ContactInfoCustomFieldHeaderResultDto } from './contact-info-custom-field-header-result-dto';
import { ContactBasicResultDto } from './contact-basic-result-dto';
import { ContactInfoSubTypeResultDto } from './contact-info-sub-type-result-dto';

export class ContactInfoEditorResultDto {
  @Type(() => ContactInfoRawDto)
  phoneData: Array<ContactInfoRawDto>;
  @Type(() => ContactInfoCustomFieldHeaderResultDto)
  phoneCustomDataFields: Array<ContactInfoCustomFieldHeaderResultDto>;
  @Type(() => ContactInfoRawDto)
  emailData: Array<ContactInfoRawDto>;
  @Type(() => ContactInfoCustomFieldHeaderResultDto)
  emailCustomDataFields: Array<ContactInfoCustomFieldHeaderResultDto>;
  @Type(() => ContactBasicResultDto)
  contacts: Array<ContactBasicResultDto>;
  @Type(() => ContactInfoSubTypeResultDto)
  phoneSubTypes: Array<ContactInfoSubTypeResultDto>;
  @Type(() => ContactInfoSubTypeResultDto)
  emailSubTypes: Array<ContactInfoSubTypeResultDto>;

  // Transient
  phoneDataCopy: Array<ContactInfoRawDto>;
  emailDataCopy: Array<ContactInfoRawDto>;
}
